import { z } from "zod/v4"

export const CoordinateSchema = z.object({
  latitude: z.number().default(0),
  longitude: z.number().default(0),
})

export type Coordinate = z.infer<typeof CoordinateSchema>
export const CoordinateEmpty = CoordinateSchema.parse({})
